import React, { useEffect, useState } from 'react'
import { ContactSearchByNumber, useContact } from '@revenuewell/logic-contact'
import { getFullContactNamesList} from './../../utils/formatter'

const useCallIdentity = (props: { phoneNumber: string }) => {
    const { getContactsByPhoneNumber } = useContact()
    const [contacts, setContacts] = useState<ContactSearchByNumber[]>()

    useEffect(() => {
        if (props.phoneNumber && props.phoneNumber.length >= 10) {
            getContactsByPhoneNumber(props.phoneNumber)
                .then(contacts => setContacts(contacts))
        }
    }, [props.phoneNumber]);

    return {
        contacts,
        contactNames: getFullContactNamesList(contacts)
    }
}

export default useCallIdentity;
